import {useQuery} from 'react-query'
import {getReportAverageAge, getReportActiveEmployee, getReportContractExpiredCurrentMonth, getReportAttendanceLog, getJobTitle, getContractType, getReportGender, getReportWorkTenure} from './_requests'

export const useGetAverageAge = (body: any) =>
  useQuery({
    queryFn: () => getReportAverageAge(body),
    queryKey: `report-average-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetActiveEmployee = (body: any) =>
  useQuery({
    queryFn: () => getReportActiveEmployee(body),
    queryKey: `active-employee-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetGender = (body: any) =>
  useQuery({
    queryFn: () => getReportGender(body),
    queryKey: `gender-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetWorkTenure = (body: any) =>
  useQuery({
    queryFn: () => getReportWorkTenure(body),
    queryKey: `work-tenure-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetContractExpiredCurrentMonth = (body: any) =>
  useQuery({
    queryFn: () => getReportContractExpiredCurrentMonth(body),
    queryKey: `contract-expired-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetAttendanceLog = (body: any) =>
  useQuery({
    queryFn: () => getReportAttendanceLog(body),
    queryKey: `attendance-log-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetJobTitle = (body: any) =>
  useQuery({
    queryFn: () => getJobTitle(body),
    queryKey: `job-title-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })

export const useGetContractType = (body: any) =>
  useQuery({
    queryFn: () => getContractType(body),
    queryKey: `contract-type-${JSON.stringify(body)}`,
    refetchOnWindowFocus: false,
    enabled: Boolean(body),
  })
